<template>
  <div class="d-flex align-center">
    <div class="d-flex align-center">
      <v-checkbox style="height: 24px" v-model="displayUnread" dark></v-checkbox>
    </div>
    <div :class="`d-flex op-text-sm ${theme.appBar.other.color}--text`">{{ $t('filter.unreadOnly') }}</div>
  </div>
</template>

<script>
import common from '@/mixins/common';

export default {
  name: 'UnreadFilter',
  mixins: [common],
  computed: {
    displayUnread: {
      get() {
        return this.$store.state.news.showUnreadOnly;
      },
      set(value) {
        this.$store.commit('news/setShowUnreadOnly', value);
      },
    },
  },
};
</script>
